import { useState } from 'react';
import { STORAGE_KEYS } from '../constants';

export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);

      try {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (storageError) {
        // localStorage.setItem can fail in incognito or when over quota.
        // In-memory state still works, so we just warn and continue.
        console.warn(`localStorage.setItem failed for key "${key}":`, storageError);
      }
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  };

  return [storedValue, setValue];
};

export const useQuizSelections = () => {
  return useLocalStorage(STORAGE_KEYS.AI_TRANS_SELECTIONS, {});
};

export const useTrackingParams = () => {
  return useLocalStorage(STORAGE_KEYS.TRACKING_PARAMS, {});
};
